import { apiBaseQuery } from '../../api/services/rtkQuery/apiBaseQuery';
import { postMissionsMutation } from './queries';
export var missionsApi = apiBaseQuery.injectEndpoints({
  endpoints: function endpoints(builder) {
    return {
      postMissions: builder.mutation(postMissionsMutation)
    };
  }
});
missionsApi.enhanceEndpoints({
  addTagTypes: ['Missions'],
  keepUnusedDataFor: 10
});
var usePostMissionsMutation = missionsApi.usePostMissionsMutation,
  postMissions = missionsApi.endpoints.postMissions;
export { usePostMissionsMutation, postMissions };